import {
  applyWhitelabelThemeAssetCssVars,
  clearWhitelabelThemeAssetCssVars,
} from '../theme/theme-assets';
import { DEFAULT_THEME_ID, resolveThemeId, type ThemeId } from '../types/theme';

function clearThemeDataAttribute(): void {
  delete document.documentElement.dataset.theme;
}

export function applyQuizheroesChrome(): void {
  clearThemeDataAttribute();
  clearWhitelabelThemeAssetCssVars();
}

export function applyWhitelabelTheme(themeId: ThemeId): ThemeId {
  if (themeId === DEFAULT_THEME_ID) {
    clearThemeDataAttribute();
  } else {
    document.documentElement.dataset.theme = themeId;
  }

  applyWhitelabelThemeAssetCssVars(themeId);

  return themeId;
}

export function applyTheme(theme: unknown): ThemeId {
  const resolved = resolveThemeId(theme);

  if (typeof theme === 'string' && theme !== resolved) {
    console.warn(`[theme] Unknown theme "${theme}", falling back to "${DEFAULT_THEME_ID}".`);
  }

  if (resolved === DEFAULT_THEME_ID) {
    applyQuizheroesChrome();
    return resolved;
  }

  return applyWhitelabelTheme(resolved);
}
